<mat-form-field appearance="outline" floatLabel="always" [class.hide-notched-outline]="!label" [hideRequiredMarker]="!label">

  <!-- Label -->
  <mat-label [id]="idPrefix + '-label'">{{label}}</mat-label>

  <mat-radio-group class="lc-radio-group" [ngClass]="layout === 'row' ? 'fx-row fx-gap-md' : 'fx-column fx-gap-xs'">
    @for (option of options; track option) {
      <mat-radio-button [checked]="option.isSelected" [disabled]="option.disabled" [lcTestId]="option" [value]="option.value" (change)="onSelect(option)">
        <!-- Label Section-->
        <div class="option-label fx-row y-center fx-gap-xs">
          <div class="overflow-ellipsis label fx-1-1-0">{{option.label}}</div>
          @if (option.description && descriptionDisplay === 'tooltip') {
            <mat-icon
              class="material-icons-outlined text-faded description-icon"
              matTooltipPosition="after"
              [matTooltip]="option.description"
              >
              info
            </mat-icon>
          }
        </div>
        @if (option.description && descriptionDisplay === 'inline') {
          <div class="option-description text-faded">{{option.description}}</div>
        }
      </mat-radio-button>
    }
    <!-- Hidden matInput plugs into formControl -->
    <input class="d-none" lcTestId matInput [errorStateMatcher]="matcher" [formControl]="formControl">
  </mat-radio-group>
  @if (formControl && formControl.invalid) {
    <mat-error class="error-message" [innerHTML]="errors" />
  }
</mat-form-field>
